<cv-generic-export [items]="items"  [fileName]="getLocalizationString('Currency_Export_File','CurrencyPending')"></cv-generic-export>
